import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-307" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-308" data-mp="3fxkxijk6olo7">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-309" data-mp="3b1cjj9hq2yim">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-310" data-mp="370aj4pc2kgf2">
          Clases de gestión cultural con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-311" data-mp="2x1kzar0m4lw6">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex min-h-[255px] flex-col rounded-2xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-312" data-mp="2s3taw6z6fhwq" data-mpi={index}>
              <div className="flex text-gold" data-id="element-313" data-mp="780l7teo3kc2">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-314" data-mp="c6bvg58vjwut" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-315" data-mp="zw66ch9mvbcf">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-316" data-mp="14u7o8yvbp4mb">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-extrabold text-white ${color}`} data-id="element-317" data-mp="q5la30hfmiwo">
                  {initials}
                </span>
                <span data-id="element-318" data-mp="1iusay64czkl3">
                  <b className="block text-sm text-ink" data-id="element-319" data-mp="1iuihg8k3uvan">{name}</b>
                  <small className="text-xs text-muted" data-id="element-320" data-mp="1nmjzyc7v9i94">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}